import React from "react";
import InputField from "../reusableComponents/InputField";
import SubmitButton from "../reusableComponents/SubmitButton";
import UserStore from "../../stores/UserStore";
import { Link, Redirect } from "react-router-dom";

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      buttonDisabled: false,
      incorrectDetails: false,
    };
  }

  setInputValue(property, val) {
    val = val.trim();

    this.setState({
      [property]: val,
    });
  }
  handleKeyDown(e) {
    if (e.key === "Enter") {
      this.doLogin();
    }
  }
  resetForm() {
    this.setState({
      password: "",
      buttonDisabled: false,
      incorrectDetails: true,
    });
  }

  async doLogin() {
    if (!this.state.username || !this.state.password) {
      return;
    }
    this.setState({
      buttonDisabled: true,
    });

    try {
      let res = await fetch("/login", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: this.state.username,
          password: this.state.password,
        }),
      });

      let result = await res.json();
      if (result && result.success) {
        UserStore.isLoggedIn = true;
        UserStore.username = result.username;
        UserStore.permissions = result.permissions;
        this.props.history.push("/");
      } else if (result && result.success === false) {
        this.resetForm();
        alert(result.msg);
      }
    } catch (e) {
      console.log(e);
      this.resetForm();
    }
  }

  render() {
    if (!UserStore.isLoggedIn) {
      return (
        <div className="app">
          <div className="container">
            <div className="loginForm">
              Log In
              <div className="errorText">
                {this.state.incorrectDetails
                  ? "The username/email or password was incorrect."
                  : ""}
              </div>
              <InputField
                type="text"
                placeholder="Username or email"
                value={this.state.username ? this.state.username : ""}
                onChange={(val) => this.setInputValue("username", val)}
                onKeyDown={(e) => {}}
              />
              <InputField
                type="password"
                placeholder="Password"
                value={this.state.password ? this.state.password : ""}
                onChange={(val) => this.setInputValue("password", val)}
                onKeyDown={(e) => this.handleKeyDown(e)}
              />
              <SubmitButton
                text="Login"
                disabled={this.state.buttonDisabled}
                onClick={() => {
                  this.doLogin();
                  //return <Redirect to="/profile" />;
                }}
              />
              <Link to="/forgot">
                <div className="hyper-link">Forgot Your Password?</div>
              </Link>
            </div>
          </div>
        </div>
      );
    } else {
      this.props.history.push("/profile");
      return <Redirect to="/profile" />;
    }
  }
}

export default LoginForm;
